// Distributor type options by CountryCode
export var DistributorTypeConfigurationsV2 = function(countryCode, USER_TYPE, strings) {
    /* Public Functions */

    var getDistributorTypeConfigurations = function(countryCode) {
        if ((countryCode.toLowerCase() + 'DistributorTypeConfigurations') in configurationCollection) {
            return new configurationCollection[countryCode.toLowerCase() + 'DistributorTypeConfigurations']();
        } else {
            return new configurationCollection.baseDistributorTypeConfigurations();
        }
    };

    /* Private Variables */

    // market-specific configurations
    var configurationCollection = {};

    /* Private Functions */

    // helper for setting up inheritance
    var inheritsFrom = function(child, parent) {
        child.prototype = Object.create(parent.prototype);
    };

    /* DistributorTypeConfigurations */

    // base configuration stubs each property setter
    var BaseDistributorTypeConfigurations = function() {};
    // BaseDistributorTypeConfigurations.prototype.getDistributor = function() {};
    BaseDistributorTypeConfigurations.prototype.getAgent = function() {};
    BaseDistributorTypeConfigurations.prototype.getRetailer = function() {};
    BaseDistributorTypeConfigurations.prototype.getDistributorTypes = function() {};
    BaseDistributorTypeConfigurations.prototype.matchDistributorTypes = function() {};
    configurationCollection.baseDistributorTypeConfigurations = BaseDistributorTypeConfigurations;

    // Default configuration overrides a subset of the property setters with behavior common across Default markets
    var DefaultDistributorTypeConfigurations = function() {};
    inheritsFrom(DefaultDistributorTypeConfigurations, configurationCollection.baseDistributorTypeConfigurations);
    DefaultDistributorTypeConfigurations.prototype.getDistributor = function() {
        var distributor = {
            type: USER_TYPE.PRIMARY_DISTRIBUTOR,
            label: strings.get('tdc_brandAffiliateButton'),
            description: strings.get('tdc_brandAffiliateDescription'),
            queryParameter: USER_TYPE.PRIMARY_DISTRIBUTOR
        };
        return distributor;
    };
    DefaultDistributorTypeConfigurations.prototype.getDistributorTypes = function() {
        var DistributorTypes =[];
        DistributorTypes.push(DefaultDistributorTypeConfigurations.prototype.getDistributor());

        return DistributorTypes;
    };
    DefaultDistributorTypeConfigurations.prototype.matchDistributorTypes = function(matchType) {
        var DistributorTypes = DefaultDistributorTypeConfigurations.prototype.getDistributorTypes();
        var match = null;
        if (matchType) {
            for (var i=0; i<DistributorTypes.length; i++) {
                if (matchType === DistributorTypes[i].type) {
                    match = DistributorTypes[i];
                }
            }
            return match;
        } else {
            return null;
        }
    };
    configurationCollection.defaultDistributorTypeConfigurations = DefaultDistributorTypeConfigurations;

    // CA configuration inherits from Default configuration
    var CaDistributorTypeConfigurations = function() {};
    inheritsFrom(CaDistributorTypeConfigurations, DefaultDistributorTypeConfigurations);
    configurationCollection.caDistributorTypeConfigurations = CaDistributorTypeConfigurations;

    // US configuration inherits from Default configuration
    var UsDistributorTypeConfigurations = function() {};
    inheritsFrom(UsDistributorTypeConfigurations, DefaultDistributorTypeConfigurations);
    configurationCollection.usDistributorTypeConfigurations = UsDistributorTypeConfigurations;


    // FR configuration inherits from Default configuration
    var FrDistributorTypeConfigurations = function() {};
    inheritsFrom(FrDistributorTypeConfigurations, BaseDistributorTypeConfigurations);
    FrDistributorTypeConfigurations.prototype.getAgent = function() {
        var agent = {
            type: USER_TYPE.AGENT,
            label: strings.get('tdc_agentButton'),
            description: strings.get('tdc_agentDescription'),
            queryParameter: USER_TYPE.AGENT
        };
        return agent;
    };
    FrDistributorTypeConfigurations.prototype.getRetailer = function() {
        var retailer = {
            type: USER_TYPE.RETAILER,
            label: strings.get('tdc_retailerButton'),
            description: strings.get('tdc_retailerDescription'),
            queryParameter: USER_TYPE.RETAILER
        };
        return retailer;
    };
    FrDistributorTypeConfigurations.prototype.getDistributorTypes = function() {
        var DistributorTypes =[];
        DistributorTypes.push(FrDistributorTypeConfigurations.prototype.getAgent(),
            FrDistributorTypeConfigurations.prototype.getRetailer());

        return DistributorTypes;
    };
    configurationCollection.frDistributorTypeConfigurations = FrDistributorTypeConfigurations;

    return {
        getDistributorTypeConfigurations: getDistributorTypeConfigurations
    };
};



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/util/customer-types/distributor-type-configurationsV2.js
// module id = 349
// module chunks = 0